import React from 'react'

// general imports
import { IconPropsType } from '../types'

const BeneficiariesIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19 3H4.99C3.88 3 3.01 3.89 3.01 5L3 19C3 20.1 3.88 21 4.99 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3ZM19 15H15C15 16.66 13.65 18 12 18C10.35 18 9 16.66 9 15H4.99V5H19V15Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default BeneficiariesIcon
